import React, { useEffect, useState } from "react";
import { Table, Button, Space, Modal, message, Card } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import api from "../../api";

const EventsPage = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const fetchEvents = async (
    page = 1,
    per_page = 25,
    search = "",
    type = "",
    date = ""
  ) => {
    setLoading(true);
    try {
      const response = await api.get(`/panel/event`, {
        params: { page, per_page, search, type, date },
      });
      setEvents(response.data.data);
      setPagination({
        ...pagination,
        current: response.data.meta.current_page,
        per_page: response.data.meta.per_page,
        total: response.data.meta.total,
      });
    } catch (error) {
      message.error("دریافت رویدادها با خطا مواجه شد");
      console.error("خطا در دریافت رویدادها:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchEventDetails = async (id) => {
    try {
      const response = await api.get(`/panel/event/${id}`);
      setSelectedEvent(response.data);
      setIsModalVisible(true);
    } catch (error) {
      message.error("دریافت اطلاعات رویداد با خطا مواجه شد");
      console.error("خطا در دریافت اطلاعات رویداد:", error);
    }
  };

  const deleteEvent = async (id) => {
    try {
      await api.delete(`/panel/event/${id}`);
      message.success("رویداد با موفقیت حذف شد");
      fetchEvents(pagination.current);
    } catch (error) {
      message.error("حذف رویداد با خطا مواجه شد");
      console.error("خطا در حذف رویداد:", error);
    }
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchEvents(pagination.current);
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const columns = [
    {
      title: "شناسه",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "عنوان",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "توضیحات",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "کاربر",
      dataIndex: "user",
      key: "user",
      render: (user) => user.name,
    },
    {
      title: "تاریخ ایجاد",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "عملیات",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => fetchEventDetails(record.id)}
          ></Button>
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => deleteEvent(record.id)}
          ></Button>
        </Space>
      ),
    },
  ];

  // ستون‌های جدول خطاها
  const failureColumns = [
    {
      title: "ردیف",
      dataIndex: "row",
      key: "row",
    },
    {
      title: "خطاها",
      dataIndex: "errors",
      key: "errors",
      render: (errors) => errors.join(", "), // نمایش خطاها به صورت متن
    },
  ];

  return (
    <Card>
      <h1 className="text-2xl mb-10 font-bold">رویدادها</h1>

      <Table
        columns={columns}
        dataSource={events}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
        rowKey="id"
      />

      {/* مودال نمایش جزئیات رویداد */}
      <Modal
        title="جزئیات رویداد"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={800} // افزایش عرض مودال
      >
        {selectedEvent && (
          <div className="mt-8">
            <p>
              <strong>عنوان:</strong> {selectedEvent.title}
            </p>
            <p>
              <strong>توضیحات:</strong> {selectedEvent.description}
            </p>
            <p>
              <strong>کاربر:</strong> {selectedEvent.user.name}
            </p>
            <p>
              <strong>تاریخ ایجاد:</strong> {selectedEvent.created_at}
            </p>

            {/* نمایش تعداد محصولات موفق و ناموفق */}
            <div className="mt-4">
              <p>
                <strong>تعداد محصولات موفق:</strong>{" "}
                {selectedEvent?.data?.count_of_products_successfully_added}
              </p>
              <p>
                <strong>تعداد محصولات ناموفق:</strong>{" "}
                {selectedEvent?.data?.count_of_products_failed_to_add}
              </p>
            </div>

            {/* نمایش خطاها در یک جدول */}
            <div className="mt-4">
              <h3 className="text-lg font-bold mb-2">خطاها</h3>
              <Table
                columns={failureColumns}
                dataSource={selectedEvent?.data?.failures}
                rowKey="row"
                pagination={false}
              />
            </div>
          </div>
        )}
      </Modal>
    </Card>
  );
};

export default EventsPage;